import React, { useCallback, useState } from 'react';
import { Text, TextProps } from './Text';
import { Tooltip } from '../Tooltip/Tooltip';

export const isTruncated = node => {
  if (!node) {
    return false;
  }

  return node.scrollWidth > node.clientWidth;
};

interface Props<T extends React.ElementType> extends TextProps {
  as?: T;
  children: React.ReactNode;
}

export function TruncatedText<T extends React.ElementType = 'div'>({
  children,
  ...rest
}: Props<T> & Omit<React.ComponentPropsWithoutRef<T>, keyof Props<T>>) {
  const [showTooltip, setShowTooltip] = useState(false);
  const ref = useCallback(node => {
    if (!node) {
      return;
    }
    setShowTooltip(isTruncated(node));
  }, []);
  return (
    <Tooltip content={children} delay={[1000, 0]} disabled={!showTooltip} placement="top">
      <Text ref={ref} isTruncated {...rest}>
        {children}
      </Text>
    </Tooltip>
  );
}
